import {
  getReportByPage,
  type ReportRequestOptions,
} from '@services/api/reports/byPage.api'
import type {
  ReportQueryParams,
  ReportKpiScalarResult,
  ReportPeriodSeriesResult,
} from '@services/api/reports/finance.api'

export interface ScheduledAppointmentsReportResult {
  patientsSeen: ReportKpiScalarResult
  avgFilledSlots: ReportKpiScalarResult
  avgOpenSlots: ReportKpiScalarResult
  avgHygieneGaps: ReportKpiScalarResult
  noShows: ReportKpiScalarResult
  filledSlotsByPeriod: ReportPeriodSeriesResult
  openSlotsByPeriod: ReportPeriodSeriesResult
  hygieneGapsByPeriod: ReportPeriodSeriesResult
  scheduledProductionByPeriod: ReportPeriodSeriesResult
  productionTargetByPeriod: ReportPeriodSeriesResult
  noShowsByPeriod: ReportPeriodSeriesResult
}

export interface ChairRoomUtilizationReportResult {
  chairTimeUsed: ReportKpiScalarResult
  chairTimeAvailable: ReportKpiScalarResult
  avgRoomsUsed: ReportKpiScalarResult
  avgRoomOperations: ReportKpiScalarResult
  utilizationRate: ReportKpiScalarResult
  chairTimeUsedByPeriod: ReportPeriodSeriesResult
  chairTimeAvailableByPeriod: ReportPeriodSeriesResult
  roomsUsedByPeriod: ReportPeriodSeriesResult
  roomsAvailableByPeriod: ReportPeriodSeriesResult
  providersWorkingByPeriod: ReportPeriodSeriesResult
  utilizationRateByPeriod: ReportPeriodSeriesResult
}

export interface HygienePerformanceReportResult {
  hygieneVisits: ReportKpiScalarResult
  hygieneOpenings: ReportKpiScalarResult
  hygieneUtilization: ReportKpiScalarResult
  recallCompliance: ReportKpiScalarResult
  hygieneReactivation: ReportKpiScalarResult
  hygieneOpeningsByPeriod: ReportPeriodSeriesResult
  hygieneUtilizationByPeriod: ReportPeriodSeriesResult
  recallComplianceByPeriod: ReportPeriodSeriesResult
  hygieneReactivationByPeriod: ReportPeriodSeriesResult
}

export const getScheduledAppointmentsReport = (
  params: ReportQueryParams,
  options?: ReportRequestOptions,
): Promise<ScheduledAppointmentsReportResult> =>
  getReportByPage<ScheduledAppointmentsReportResult>(
    '/operations/scheduled-appointments',
    params,
    options,
  )

export const getChairRoomUtilizationReport = (
  params: ReportQueryParams,
  options?: ReportRequestOptions,
): Promise<ChairRoomUtilizationReportResult> =>
  getReportByPage<ChairRoomUtilizationReportResult>(
    '/operations/chair-room-utilization',
    params,
    options,
  )

export const getHygienePerformanceReport = (
  params: ReportQueryParams,
  options?: ReportRequestOptions,
): Promise<HygienePerformanceReportResult> =>
  getReportByPage<HygienePerformanceReportResult>(
    '/operations/hygiene-performance',
    params,
    options,
  )
